export default "__VITE_ASSET__3dbc2533__"